import { render, staticRenderFns } from "./RouterSwitch.vue?vue&type=template&id=63bcee5e"
import script from "./RouterSwitch.vue?vue&type=script&lang=js"
export * from "./RouterSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports